(function () {
  'use strict';

  // Variáveis
  const $popup = document.getElementById('popup-cookies');
  const $button = document.getElementById('popup-cookies-btn');

  if ($popup) {
    // Evento do botão (Grava o cookie)
    $button.addEventListener('click', function (ev) {
      ev.preventDefault();
      localStorage.setItem('cookie_popup', 'true');
      $popup.classList.remove('active');
    });

    // Verifica se já foi aceito
    if (!localStorage.getItem('cookie_popup')) {
      setTimeout(function () {
        $popup.classList.add('active');
      }, 2000);
    }
  }
})();
